import { render, staticRenderFns } from "./RequestInvoice.vue?vue&type=template&id=27800c8c&scoped=true"
import script from "./RequestInvoice.vue?vue&type=script&lang=js"
export * from "./RequestInvoice.vue?vue&type=script&lang=js"
import style0 from "./RequestInvoice.vue?vue&type=style&index=0&id=27800c8c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27800c8c",
  null
  
)

export default component.exports